/**
 * Statistiques scolarité (carte sous le header de page).
 */
import type { UserSchoolStats } from '@sphere/user/domain';
import styles from './profile-stats-panel.module.scss';

interface ProfileStatsPanelProps {
  stats: UserSchoolStats;
}

export function ProfileStatsPanel({ stats }: ProfileStatsPanelProps) {
  return (
    <section className={styles.card} aria-label="Statistiques de scolarité">
      <div className={styles.stats} role="list">
        <StatItem
          label="Établissements"
          value={stats.activeEstablishments}
          total={stats.totalEstablishments}
        />
        <StatItem
          label="Classes"
          value={stats.activeClasses}
          total={stats.totalClasses}
        />
        <StatItem
          label="Groupes"
          value={stats.activeGroups}
          total={stats.totalGroups}
        />
        <StatItem label="Matières" value={stats.totalTeachings} />
      </div>
    </section>
  );
}

function StatItem({
  label,
  value,
  total,
}: {
  label: string;
  value: number;
  total?: number;
}) {
  return (
    <div className={styles.statItem} role="listitem">
      <div className={styles.statValue}>
        {value}
        {total !== undefined && total !== value && (
          <span className={styles.statTotal}>/{total}</span>
        )}
      </div>
      <div className={styles.statLabel}>{label}</div>
    </div>
  );
}
